import { render, staticRenderFns } from "./TableComponents.vue?vue&type=template&id=64c39e52&scoped=true&"
import script from "./TableComponents.vue?vue&type=script&lang=js&"
export * from "./TableComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c39e52",
  null
  
)

export default component.exports